import React, { useState, useCallback, useEffect } from 'react'
import { merge } from 'lodash'
import { UseRequestProvider } from 'ahooks'
import { ConfigProvider } from 'antd'
import * as Sentry from '@sentry/react'
import { Switch, BrowserRouter } from 'react-router-dom'
import { AsyncConfiguration, AuthorizedConfiguration, SentryConfiguration } from '@/configuration'
import Router from '@/routers'
import { useSelector } from '@/store'
import { PageLoading } from '@/components/Loading'
import { ScopeProvider } from '@/components'
import GlobalError from '@/components/GlobalError'
import { LANGUAGE } from '@/constants/language'
import '@/styles/common/reset.less'
import { SWRConfig } from 'swr'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import { useMount } from 'ahooks'

/**
 * TODO: 废弃，后续需要补充用户同域互斥更新逻辑
 * @param e
 */
window.onstorage = (e) => {
  if (e.key === 'loginSuccess') {
    window.location.reload()
  }
}
//TODO:  没有语种切换的能力，需要吗？
const App: React.FC = () => {
  const [antdLocale, setantdLocale] = useState<any>({})
  /**  */
  const languageStore = useSelector((state) => state.language)

  const getAntdLang = useCallback((lang: string) => {
    const langKey = Object.keys(LANGUAGE).filter((key) => LANGUAGE[key]?.lang === lang)[0]
    return LANGUAGE[langKey]?.antd
  }, [])

  const changeLanguageCallback = useCallback(
    (lang) => {
      // antd组件加载locale文件，以及重写ant部分多语言
      Promise.all([import(`antd/lib/locale/${getAntdLang(lang)}.js`), import(`./locales/antd/${getAntdLang(lang)}.ts`)])
        .then((res: any[]) => {
          const [localeRes, extraLocaleRes] = res || []
          const locale = merge(localeRes?.default || {}, extraLocaleRes?.default || {})
          if (Object.keys(locale).length) {
            setantdLocale(locale)
          } else {
            return Promise.reject(`[antd] 语言包{${lang}}加载失败`)
          }
        })
        .catch((e) => {
          /* eslint-disable no-console  */
          console.error(e)
        })
    },
    [getAntdLang]
  )

  useEffect(() => {
    changeLanguageCallback(languageStore.lang)
  }, [changeLanguageCallback, languageStore])

  /**
   * TODO: 可以放在render的界面
   */
  useMount(() => {
    dayjs.extend(updateLocale)
    /**
     * 每年一月四号那周定为第一周
     * 第1个属性固定是en
     */
    dayjs.updateLocale('en', {
      yearStart: 4,
    })
  })

  return (
    /** 在sentry注入用户信息 */
    <SentryConfiguration>
      <SWRConfig
        value={{
          /** 关闭聚焦之后自动验证 */
          revalidateOnFocus: false,
        }}
      >
        <ConfigProvider autoInsertSpaceInButton={false} locale={antdLocale}>
          {/* 
            useRequest 在内部执行的时候发现错误，会包裹一层promise，导致触发sentry过滤器过滤掉了，从而无法上报，加了这个属性之后throwOnError，可以避免promise的包裹
           */}
          <UseRequestProvider
            value={{
              throwOnError: true,
            }}
          >
            {/*
             * TODO: ScopeProvider 无用的provider
             */}
            <ScopeProvider>
              <BrowserRouter>
                {/* 
                fallback
                process 
              */}
                <AsyncConfiguration>
                  {/* 权限配置，实际上是空的 */}
                  <AuthorizedConfiguration>
                    {/* 全局拦截器 */}
                    <GlobalError />
                    <Switch>
                      <React.Suspense fallback={<PageLoading></PageLoading>}>
                        <Router />
                      </React.Suspense>
                    </Switch>
                  </AuthorizedConfiguration>
                </AsyncConfiguration>
              </BrowserRouter>
            </ScopeProvider>
          </UseRequestProvider>
        </ConfigProvider>
      </SWRConfig>
    </SentryConfiguration>
  )
}

App.displayName = 'App'
export default Sentry.withProfiler(App)

// 